<template>
  <div class="item B1 sepTop" @click="go(item)">
    <div class="name S8 T1">{{ item.descriPrifix }}</div>
    <div class="manager S6 T3">{{ item.descriSuffix }}</div>
    <div class="time S8 T3">{{ item.expireTimeStr}}</div>
    <van-button
      type="info"
      size="small"
      class="button"
      @click.stop="goSearch(item)"
      v-if="isSwitchable"
    >更换</van-button>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import util from '@/util/util'
import { Button } from 'vant'

export default {
  name: 'PermissionItem',
  components: {
    'van-button': Button
  },
  props: {
    item: {
      type: Object
    },
    isSwitchable: {
      type: Boolean
    }
  },
  methods: {
    dayjs,
    go(item) {
      // if (this.isSwitchable) {
      //   this.$router.push({
      //     path: './search',
      //     query: { type: item.type, productId: item.productId }
      //   })
      // } else {
      const url = item.url
      util.go(url)
      // }
    },
    goSearch(item) {
      if (this.isSwitchable) {
        this.$router.push({
          path: './search',
          query: { type: item.type, productId: item.productId }
        })
      }
    }
  }
}
</script>

<style scoped>
.button {
  margin-right: 20px;
}
.item {
  line-height: 88px;
  height: 88px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.name {
  margin-left: 30px;
}

.manager {
  margin-left: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex-grow: 1;
  width: 0;
}

.time {
  margin-right: 30px;
}
</style>